<h2 mat-dialog-title>Add new fuel price index</h2>
<form [formGroup]="FuelPriceIndexForm">
  <mat-dialog-content class="fields-container">
    <mat-form-field appearance="fill">
      <mat-label>Symbol PLATTS</mat-label>
      <input matInput formControlName="symbol" name="symbol" maxlength="50" />
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Index Name PLATTS</mat-label>
      <input matInput formControlName="name" name="name" maxlength="50" />
    </mat-form-field>
    <div class="fields-row-container">
      <mat-form-field appearance="fill">
        <mat-label>UOM1</mat-label>
        <mat-select formControlName="uom1" name="uom1">
          <mat-option value="BLL">BLL</mat-option>
          <mat-option value="MT">MT</mat-option>
          <mat-option value="USG">USG</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>UOM2</mat-label>
        <mat-select formControlName="uom2" name="uom2">
          <mat-option value="USC">USC</mat-option>
          <mat-option value="USD">USD</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Cancel</button>
    <button
      mat-button
      cdkFocusInitial
      [disabled]="!FuelPriceIndexForm.valid"
      (click)="onAdd()"
    >
      Add
    </button>
  </mat-dialog-actions>
</form>
